import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import { TableChiTietVayThem } from "./TableChiTietVayThem";
import { ChiTietTra } from "./ChiTietTra";
import NhanVayApi from "service/nhanVayApi";
import { getListNhanVay, updateDataSearch } from "../../../../actions/NhanVay/";
import { currentDate } from "utils/formatDate";
import { useSelector, useDispatch } from "react-redux";
import { convertToNumber } from "utils/numberExtension";
import { pushNotification } from "utils/notifications";
import { formatNumber } from "utils/currencyFormat";
import DateTimePicker from "../../../../components/GenericComponent/DateTimePicker";
import { convertDate } from "utils/formatDate";
import { formatDayMonth } from "utils/formatDate";
import InputDocTien from "components/GenericComponent/NumberInput/InputDocTien";
import { Controller, useForm } from "react-hook-form";
import { ThongTinHopDong } from "./ThongTinHopDong";
import useHinhThucThanhToan from "utils/useHinhThucThanhToan";

export const VayThem = (props) => {
  const currentForm = useForm();
  const { control } = currentForm;
  const dataSearch = useSelector((state) => state.dataSearchNhanVay);

  const dispatch = useDispatch();

  const initDataVayThem = {
    NhanVayId: props.NhanVayId,
    NguoiNhan: props.TenChuNo,
    NgayThanhToan: currentDate(),
    TienThanhToan: 0,
    PhiKhac: 0,
    PhiKho: 0,
    GhiChu: "",
  };
  const [dataVayThem, setdataVayThem] = useState(initDataVayThem);

  const updateTextValue = (field) => (e) => {
    setdataVayThem({
      ...dataVayThem,
      [field]: e.target.value,
    });
    if (e.target.value === "") {
      setErrors({
        ...errors,
        nguoiNhan: "Tên người nhận không được để trống",
      });
      NguoiNhan.current.focus();
    } else {
      setErrors({
        ...errors,
        nguoiNhan: "",
      });
    }
  };
  const onChangeNumber = (field) => (evt) => {
    setdataVayThem({
      ...dataVayThem,
      [field]: convertToNumber(evt.target.value),
    });
    if (evt.target.value === "") {
      setErrors2({
        ...errors2,
        tienThanhToan: "Nhập số tiền thanh toán",
      });
      TienThanhToan.current.focus();
    } else if (evt.target.value === 0) {
      setErrors2({
        ...errors2,
        tienThanhToan: "Số tiền thanh toán phải lớn hơn 0",
      });
      TienThanhToan.current.focus();
    } else {
      setErrors2({
        ...errors2,
        tienThanhToan: "",
      });
    }
  };

  const onChangeNumber1 = (field) => (e) => {
    setdataVayThem({
      ...dataVayThem,
      [field]: convertToNumber(e.value),
    });
  };
  const onChangeDate = (field) => (evt) => {
    setdataVayThem({
      ...dataVayThem,
      [field]: formatDayMonth(evt),
    });
    if (evt === "null") {
      setErrors1({
        ...errors1,
        ngayThanhToan: "Nhập ngày thanh toán",
      });
      // NgayThanhToan.current.focus();
    } else {
      setErrors1({
        ...errors1,
        ngayThanhToan: "",
      });
    }
    console.log(evt, "2");
  };

  const onChangeDate1 = (field) => (evt) => {
    setdataVayThem({
      ...dataVayThem,
      [field]: evt,
    });
  };

  //Thông báo
  const initErrors = {
    nguoiNhan: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const initErrors1 = {
    ngayThanhToan: "",
  };
  const [errors1, setErrors1] = useState(initErrors1);
  const initErrors2 = {
    tienThanhToan: "",
  };
  const [errors2, setErrors2] = useState(initErrors2);
  const NguoiNhan = React.createRef();
  const NgayThanhToan = React.createRef();
  const TienThanhToan = React.createRef();
  //Ref chặn bấm Xác nhận 2 lần liên tiếp trước khi state kịp render lại
  const isSavingRef = React.useRef(false);
  const [isSaving, setIsSaving] = useState(false);
  const batHinhThucThanhToan = useHinhThucThanhToan();
  const [hinhThucThanhToan, setHinhThucThanhToan] = useState("0");
  const onSubmit = () => {
    if (isSavingRef.current) return;
    // Validate

    if (dataVayThem.NguoiNhan === "") {
      setErrors({
        ...errors,
        nguoiNhan: "Tên người nhận không được để trống",
      });
      NguoiNhan.current.focus();
      return;
    } else if (
      dataVayThem.NgayThanhToan === "null" ||
      dataVayThem.NgayThanhToan === null ||
      dataVayThem.NgayThanhToan === ""
    ) {
      setErrors1({
        ...errors1,
        ngayThanhToan: "Nhập ngày thanh toán",
      });
      // NgayThanhToan.current.focus();

      return;
    } else if (dataVayThem.TienThanhToan === "") {
      setErrors2({
        ...errors2,
        tienThanhToan: "Nhập số tiền thanh toán",
      });
      TienThanhToan.current.focus();

      return;
    } else if (dataVayThem.TienThanhToan === 0) {
      setErrors2({
        ...errors2,
        tienThanhToan: "Số tiền thanh toán phải lớn hơn 0",
      });
      TienThanhToan.current.focus();

      return;
    } else {
      //  setRefreshing(true);
      isSavingRef.current = true;
      setIsSaving(true);
      NhanVayApi.vayThemNhanVay({
        ...dataVayThem,
        HinhThucThanhToan: batHinhThucThanhToan
          ? parseInt(hinhThucThanhToan, 10)
          : null,
      })
        .then((response) => {
          if (response.status !== 200) {
            //Mất mạng/timeout: apisauce trả data null, server có thể đã lưu nên nhắc kiểm tra trước khi làm lại
            pushNotification(
              response.data ||
                "Không nhận được phản hồi từ máy chủ, vui lòng kiểm tra lại lịch sử vay thêm trước khi thử lại!",
              "error",
              "TOP_CENTER",
              response.data ? 1000 : 5000
            );
            return;
          } else {
            pushNotification(
              "Vay thêm thành công",
              "success",
              "TOP_CENTER",
              1000
            );
            props.onHide();
            dispatch(getListNhanVay(dataSearch));
          }
        })
        .finally(() => {
          isSavingRef.current = false;
          setIsSaving(false);
        });
    }
  };
  return (
    <Modal
      {...props}
      size="modal-xl modal-xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-bank-minus"></i>
          </span>
          Vay thêm
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <div className="row">
          <div className="col-md-12 col-lg-4 pad-right0">
            <div className="">
              <ul className="nav nav-tabs bg-tab" style={{ height: 50 }}>
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    id="base-tab1"
                    data-toggle="tab"
                    aria-controls="tab1"
                    href="#tab-thongtintt"
                    aria-expanded="true"
                    style={{ height: 35 }}
                  >
                    <h4>Nội dung vay</h4>
                  </a>
                </li>
              </ul>
              <div className="tab-content px-1 pt-1 pb-1 bg-content-tab">
                <div
                  className="tab-pane active"
                  id="tab-thongtintt"
                  aria-expanded="true"
                  aria-labelledby="base-tab1"
                >
                  <div className="detail-tattoan">
                    <div className="row">
                      <div className="col-md-6">
                        <TextInputOnRow
                          labelClass="label-control"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Người nhận"
                          inputProps={{
                            name: "dataVayThem.NguoiNhan",
                            ref: NguoiNhan,
                            onChange: updateTextValue("NguoiNhan"),
                            value: dataVayThem.NguoiNhan,
                          }}
                        ></TextInputOnRow>
                        {errors.nguoiNhan && (
                          <span className="canh-bao-red">
                            {errors.nguoiNhan}
                          </span>
                        )}
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label for="projectinput1">Ngày vay thêm</label>
                          <DateTimePicker
                            value={convertDate(dataVayThem.NgayThanhToan)}
                            name="NgayThanhToan"
                            onChange={onChangeDate("NgayThanhToan")}
                            // customInputRef={NgayThanhToan}
                          ></DateTimePicker>
                        </div>
                        {errors1.ngayThanhToan && (
                          <span className="canh-bao-red">
                            {errors1.ngayThanhToan}
                          </span>
                        )}
                      </div>

                      {/* <InputDocTien
                        labelClass="col-md-6 label-control"
                        inputClass="form-control input-sm"
                        inputWrapClass="col-md-8"
                        wrapperClass="form-group row"
                        labelText="Số tiền thanh toán"
                        placeholder="10,000,000"
                        inputProps={{
                          name: "customer.Phone",
                          onChange: onChangeNumber1("TienThanhToan"),
                          value: formatNumber(dataVayThem.TienThanhToan),
                          // getInputRef: TienThanhLy,
                          control: control,
                        }}
                      ></InputDocTien> */}

                      <div className="col-md-6">
                        <TextInputOnRow
                          labelClass="label-control"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Tiền vay thêm"
                          inputProps={{
                            name: "dataVayThem.TienThanhToan",
                            ref: TienThanhToan,
                            onChange: onChangeNumber("TienThanhToan"),
                            value: formatNumber(dataVayThem.TienThanhToan),
                          }}
                        ></TextInputOnRow>
                        {errors2.tienThanhToan && (
                          <span className="canh-bao-red">
                            {errors2.tienThanhToan}
                          </span>
                        )}
                      </div>

                      <div className="col-md-6">
                        <TextInputOnRow
                          labelClass="label-control"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Phí khác"
                          inputProps={{
                            name: "dataVayThem.PhiKhac",
                            // ref: register,
                            onChange: onChangeNumber("PhiKhac"),
                            value: formatNumber(dataVayThem.PhiKhac),
                          }}
                        ></TextInputOnRow>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <label for="projectinput8">Ghi chú</label>
                          <textarea
                            id="projectinput8"
                            rows="3"
                            className="form-control input-sm"
                            name="GhiChu"
                            value={dataVayThem.GhiChu}
                            onChange={updateTextValue("GhiChu")}
                          ></textarea>
                        </div>
                      </div>

                      {batHinhThucThanhToan && (
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Hình thức thanh toán</label>
                            <select
                              className="form-control input-sm"
                              value={hinhThucThanhToan}
                              onChange={(e) => setHinhThucThanhToan(e.target.value)}
                            >
                              <option value="0">Tiền mặt</option>
                              <option value="1">Chuyển khoản</option>
                            </select>
                          </div>
                        </div>
                      )}

                      <div className="col-md-12">
                        <div className="text-right">
                          <button
                            type="button"
                            className="btn btn-new-main btn-checknew"
                            onClick={onSubmit}
                            disabled={isSaving}
                          >
                            {isSaving ? (
                              <>
                                <span className="spinner-border spinner-border-sm"></span>
                                &nbsp; Đang xử lý...
                              </>
                            ) : (
                              <>
                                <span className="btn-icon-left">
                                  <i className="mdi mdi-check-underline-circle"></i>
                                </span>{" "}
                                Xác nhận
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12 col-lg-8">
            <div className="tattoan-formright">
              <ul className="nav nav-tabs bg-tab" style={{ height: 50 }}>
                <li className="nav-item disk-mobileactive">
                  <a
                    className="nav-link active"
                    id="base-tab1"
                    data-toggle="tab"
                    aria-controls="tab1"
                    href="#tab-noidung"
                    aria-expanded="true"
                    style={{ height: 35 }}
                  >
                    <h4>Thông tin hợp đồng</h4>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link "
                    id="base-tab1"
                    data-toggle="tab"
                    aria-controls="tab1"
                    href="#tab-detailtt"
                    aria-expanded="true"
                    style={{ height: 35 }}
                  >
                    <h4>Chi tiết trả</h4>
                  </a>
                </li>
              </ul>
              <div className="tab-content px-1 pt-1 pb-1 bg-content-tab">
                <div
                  className="tab-pane active"
                  id="tab-noidung"
                  aria-expanded="true"
                  aria-labelledby="base-tab1"
                >
                  <ThongTinHopDong
                    NhanVayId={props.NhanVayId}
                    item={props.item}
                  />
                </div>
                <div
                  className="tab-pane"
                  id="tab-detailtt"
                  aria-expanded="true"
                  aria-labelledby="base-tab1"
                >
                  <ChiTietTra nhanvayId={props.NhanVayId} />

                  <div className="footer-page-new">
                    <div className="row">
                      <div className="col-xl-12 col-lg-12">
                        <div className="paniation-new d-flex just-end just-center-mobile">
                          <nav aria-label="Page navigation">
                            {/* <Pagination
                              activePage={1}
                              itemsCountPerPage={15}
                              totalItemsCount={10}
                              pageRangeDisplayed={5}
                              onChange={handlePageChange}
                              itemClass="page-item"
                              linkClass="page-link"
                              activeClass="active"
                            /> */}
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="list-history">
            <h4>Lịch sử vay thêm</h4>
            <TableChiTietVayThem nhanvayId={props.NhanVayId} />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
